module.exports = __webpack_public_path__ + "res/img_user_dummy.5b6a25c1296c1f7564f359b03fb4987e.png";